__turbopack_context__.v({
  "deliveryDescription": "kZFd-q_deliveryDescription",
  "deliveryDescriptionWithTracking": "kZFd-q_deliveryDescriptionWithTracking",
  "trackingButton": "kZFd-q_trackingButton",
  "trackingDetails": "kZFd-q_trackingDetails",
  "trackingLink": "kZFd-q_trackingLink",
});
